import React from 'react';
import styles from './ThreeDotsLoader.module.css';

const Spinner = () => {
    return (
        <div className={styles.loaderContainer}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
        </div>
    );
};

export default Spinner;
